import { string } from 'prop-types';
import React from 'react';
import { View } from 'react-native';

import { Avatar, Text } from '../../reactor/components';
import { LAYOUT } from '../../reactor/common';

import styles from './Location.style';

const Location = ({
  author, avatar, color, country, title, ...inherit
}) => (
  <View style={[styles.container, inherit.style]}>
    <Avatar image={avatar} />
    <View style={styles.content}>
      <Text color={color} numberOfLines={1} subtitle level={LAYOUT.VIEWPORT.PORTRAIT ? 3 : 2}>
        {title + (country ? ` - ${country}` : '')}
      </Text>
      <Text caption color={color} numberOfLines={1} level={LAYOUT.VIEWPORT.PORTRAIT ? 2 : 1}>
        {author}
      </Text>
    </View>
  </View>
);

Location.propTypes = {
  author: string.isRequired,
  avatar: string.isRequired,
  color: string,
  country: string,
  title: string.isRequired,
};

Location.defaultProps = {
  color: undefined,
  country: undefined,
};

export default Location;
